import React from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  requestAddNewTemplate,
  setNewEmailTemplateTitle,
  setNewSmsTemplateTitle,
} from "../../../../../redux/actions/new-template";
import { SolidButton } from "../../../../library/button";
import { Input } from "../../../../library/input";
import { Label } from "../../../../library/label";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";

import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const templateRef = useSelector((state) => state.newTemplate);

  const addLoading = useSelector(
    (state) => state.newTemplate.createTemplate.loading
  );
  const companyId = useSelector(
    (state) =>
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  const handleTitleChange = (title) => {
    if (templateRef.type === "email") {
      dispatch(setNewEmailTemplateTitle(title));
    } else {
      dispatch(setNewSmsTemplateTitle(title));
    }
  };

  const renderTemplateName = () => {
    if (templateRef.type === "email") {
      return templateRef.emailTemplate.title;
    } else {
      return templateRef.smsTemplate.title;
    }
  };

  const clickAddNewTemplate = () => {
    if (templateRef.type === "email") {
      if (templateRef.emailTemplate.title) {
        dispatch(
          requestAddNewTemplate({
            details: templateRef.emailTemplate,
            companyId: companyId,
            type: templateRef.type,
          })
        );
      } else {
        sendErrorNotification("Vennligst oppgi et navn.");
      }
    } else {
      if (templateRef)
        dispatch(
          requestAddNewTemplate({
            details: templateRef.smsTemplate,
            companyId: companyId,
            type: templateRef.type,
          })
        );
    }
  };

  return (
    <div className="new-template-form-container">
      <Row className="single-result-row statistics-row">
        <Col className="result-col text-left">
          <Label version={1} weight="bold">
            Navn på mal
          </Label>
          <Input
            onChange={(e) => handleTitleChange(e.target.value)}
            value={renderTemplateName()}
            type="text"
            placeholder="Min mal"
          />
        </Col>
        <Col className="result-col button text-right">
          <SolidButton
            color="blue"
            size="regular"
            onClick={() => clickAddNewTemplate()}
            title={addLoading ? "Oppretter.." : "Opprett mal"}
            icon={
              addLoading ? (
                <i className="fas fa-circle-notch fa-spin"></i>
              ) : (
                <i className="fas fa-plus"></i>
              )
            }
          />
        </Col>
      </Row>
      <hr />
    </div>
  );
};

export default Index;
